module.exports = __webpack_public_path__ + "static/media/driver-ready-logo.1154a04c.png";